import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SliderWithThumbnails from '../SliderWithThumbnails';
import projectsData from './projectsData'; // Import project data
import '../../styles/ProjectDetails.css';

const ProjectDetails = () => {
  // Get the project slug from URL
  const { slug } = useParams();
  
  // Find the matching project
  const project = projectsData.find((proj) => proj.slug === slug);

  // If no project is found, show an error message
  if (!project) {
    return (
      <section className='project_details_sec'>
        <Header links={[
          { text: 'HOME', to: '/' },
          { text: 'ABOUT', to: '/about' },
          { text: 'PROJECTS', to: '/all_projects' }, 
          { text: 'GALLERY', to: '/#gallery_id' },
          { text: 'CONTACT', to: '/#contact_id' }
        ]} />
        <div className='project_description_container'>
          <h2>Project Not Found</h2>
          <p>The project you are looking for does not exist.</p>
          <a href='/all_projects' className='view_project_text'>{'<'} Back To Projects</a>
        </div>
        <Footer />
      </section>
    );
  }

  return (
    <section className='project_details_sec'>
      {/* Header Component */}
      <Header links={[
        { text: 'HOME', to: '/' },
        { text: 'ABOUT', to: '/about' },
        { text: 'PROJECTS', to: '/all_projects' }, 
        { text: 'GALLERY', to: '/#gallery_id' },
        { text: 'CONTACT', to: '/#contact_id' }
      ]} />

      {/* Slider Component for Images */}
      <SliderWithThumbnails images={project.images} className='slider_container_one' />

      {/* Project Description */}
      <div className='project_description_container'>
        <div className='project_description_title'>
          <h2>{project.name}</h2>
          <h3>{project.location}</h3>
          <p>{project.date}</p>
          <a href='/all_projects' className='view_project_text'>{'<'} Back To Projects</a>
        </div>

        {/* Rendering Multi-Paragraph Description */}
        <div className='project_description_p'>
          {project.description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>

      {/* Footer Component */}
      <Footer />
    </section>
  );
};

export default ProjectDetails;
